import type { SxProps, Theme } from '@mui/material';

export const card: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  height: 'fit-content',
  maxWidth: '600px',
};

export const cardContent: SxProps<Theme> = {
  p: 3,
};

export const headerContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  mb: 3,
};

export const shieldIcon: SxProps<Theme> = {
  width: 40,
  height: 40,
};

export const contentContainer: SxProps<Theme> = {
  flexGrow: 1,
};

export const title: SxProps<Theme> = {
  mb: 0.5,
};

export const businessModel: SxProps<Theme> = {
  mb: 0.5,
  fontStyle: 'italic',
};

export const productionChip: SxProps<Theme> = {
  backgroundColor: '#f44336',
  color: 'white',
  fontWeight: 500,
};

export const developmentChip: SxProps<Theme> = {
  backgroundColor: '#ff9800',
  color: 'white',
  fontWeight: 500,
};

export const fieldContainer: SxProps<Theme> = {
  mb: 3,
};

export const fieldLabel: SxProps<Theme> = {
  mb: 1,
};

export const textField: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: (theme) =>
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.02)',
  },
};

export const buttonContainer: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
};

export const iconButton: SxProps<Theme> = {
  color: 'text.secondary',
};

export const alertIcon: SxProps<Theme> = {
  width: 24,
  height: 24,
};

export const productionAlert: SxProps<Theme> = {
  backgroundColor: (theme) =>
    theme.palette.mode === 'dark' ? 'rgba(244, 67, 54, 0.1)' : 'rgba(244, 67, 54, 0.1)',
  color: (theme) => (theme.palette.mode === 'dark' ? '#ffcdd2' : '#c62828'),
  border: (theme) =>
    `1px solid ${
      theme.palette.mode === 'dark' ? 'rgba(244, 67, 54, 0.3)' : 'rgba(244, 67, 54, 0.3)'
    }`,
  '& .MuiAlert-icon': {
    color: (theme) => (theme.palette.mode === 'dark' ? '#ffcdd2' : '#c62828'),
  },
};

export const developmentAlert: SxProps<Theme> = {
  backgroundColor: (theme) =>
    theme.palette.mode === 'dark' ? 'rgba(255, 152, 0, 0.1)' : 'rgba(255, 152, 0, 0.1)',
  color: (theme) => (theme.palette.mode === 'dark' ? '#ffcc02' : '#e65100'),
  border: (theme) =>
    `1px solid ${
      theme.palette.mode === 'dark' ? 'rgba(255, 152, 0, 0.3)' : 'rgba(255, 152, 0, 0.3)'
    }`,
  '& .MuiAlert-icon': {
    color: 'inherit',
  },
}; 